/*
 * @Author: leventlei
 * @Date: 2024-01-07 09:49:51
 * @LastEditTime: 2025-01-09 19:45:10
 * @LastEditors: leventlei
 * @Description:侧边栏一级菜单
 * @FilePath: /IOT4CMS/src/layouts/baseLayout/menu/components/firstLevelMenu.tsx
 */
import React, { FC, useEffect, useState } from 'react'

import iconContent from '@/assets/images/layout/icon_menu_content.png'
import iconHome from '@/assets/images/layout/icon_menu_home.png'
import iconOperation from '@/assets/images/layout/icon_menu_operation.png'
import iconPackage from '@/assets/images/layout/icon_menu_package.png'
import iconSetting from '@/assets/images/layout/icon_menu_setting.png'
import iconSpace from '@/assets/images/layout/icon_menu_space.png'
import iconThing from '@/assets/images/layout/icon_menu_thing.png'
import iconVip from '@/assets/images/layout/icon_menu_vip.png'
import { GlobalModelState } from '@/models/connect'
import { LeftOutlined } from '@ant-design/icons'
import { Menu, MenuProps } from 'antd'
import { Dispatch, Loading, connect, history, useLocation } from 'umi'

import styles from '../index.less'

export type MenuItem = Required<MenuProps>['items'][number]

function getItem(
	label: React.ReactNode,
	key: React.Key,
	icon?: React.ReactNode,
	children?: MenuItem[],
	type?: 'group',
): MenuItem {
	return {
		key,
		icon,
		children,
		label,
		type,
	} as MenuItem
}

export interface FirstLevelMenuProps {
	dispatch: Dispatch
	global: GlobalModelState
	loading: boolean
}

// 切换二级菜单时需要把地址栏的query参数的路由menuCode
export const needTakeQuerysMenuPathnames = [
	'/iotInstanceDetail', // 智能化-实例详情
	'/iotProduct', // 智能化-产品管理
	'/iotDevice', // 智能化-设备管理
	'/iotDeviceGroup', // 智能化-设备组管理
	'/iotScene', // 智能化-场景设置
	'/iotSceneControl', // 智能化-场景控制
]

/* 根据pathname判断一级菜单Icon */
const getIconByPathname = (pathname: string) => {
	let iconPath: string = ''
	switch (pathname) {
		case '/home':
			iconPath = iconHome
			break
		case '/package':
			iconPath = iconPackage
			break
		case '/justOperation':
			iconPath = iconOperation
			break
		case '/spaceOperation':
			iconPath = iconSpace
			break
		case '/iot':
			iconPath = iconThing
			break
		case '/property':
			iconPath = iconThing
			break
		case '/role':
			iconPath = iconSetting
			break
		case '/member':
			iconPath = iconVip
			break
		case '/contentOperation':
			iconPath = iconContent
			break
		default:
			break
	}

	if (iconPath.length > 0) {
		return (
			<img
				src={iconPath}
				alt="menuIcon"
				style={{
					display: 'inline-block',
					width: '22px',
					height: '22px',
					marginRight: '4px',
				}}
			/>
		)
	} else {
		return (
			<span
				style={{
					display: 'inline-block',
					width: '22px',
					height: '22px',
					marginRight: '4px',
				}}
			/>
		)
	}
}

const FirstLevelMenu: FC<FirstLevelMenuProps> = ({
	dispatch,
	global,
	loading,
}) => {
	const location = useLocation() as any
	const locationQuerys = location.query
	const { menusData } = global
	const [openKeys, setOpenKeys] = useState<string[]>([])
	const [menuItems, setMenuItems] = useState<MenuItem[]>([])
	const [specialMenuItems, setSpecialMenuItems] = useState<MenuItem[]>([])
	const [rootSubmenuKeys, setRootSubmenuKeys] = useState<string[]>([]) // 一级菜单的path
	const [selectedKeys, setSelectedKeys] = useState<string[]>()

	useEffect(() => {
		if (menusData.length > 0) {
			renderMenuItems()
			renderSpecialMenuItems()
		}
	}, [menusData])

	useEffect(() => {
		setSelectedKeys([location.pathname])
	}, [location.pathname])

	/* 渲染菜单项 */
	const renderMenuItems = () => {
		let firstLevelMenus: MenuItem[] = []
		let currentRootSubmenuKeys: string[] = []
		let currentOpenKeys: string[] = []
		for (let i = 0; i < menusData?.length; i++) {
			const firstLevelMenu = menusData[i]
			let secondLevelMenus: MenuItem[] = []
			if (firstLevelMenu.path === location.pathname) {
				currentOpenKeys.push(firstLevelMenu.path)
			}
			for (let j = 0; j < firstLevelMenu?.routes.length; j++) {
				const secondLevelMenu = firstLevelMenu?.routes[j]
				let thirdLevelMenus: MenuItem[] = []
				if (secondLevelMenu.path === location.pathname) {
					currentOpenKeys.push(firstLevelMenu.path)
					currentOpenKeys.push(secondLevelMenu.path)
				}
				for (let k = 0; k < secondLevelMenu?.routes.length; k++) {
					const thirdLevelMenu = secondLevelMenu?.routes[k]
					if (thirdLevelMenu.path === location.pathname) {
						currentOpenKeys.push(firstLevelMenu.path)
						currentOpenKeys.push(secondLevelMenu.path)
						currentOpenKeys.push(thirdLevelMenu.path)
					}
					thirdLevelMenus.push(
						getItem(
							thirdLevelMenu.title,
							thirdLevelMenu.path,
							getIconByPathname(''),
						),
					)
				}
				if (thirdLevelMenus.length > 0) {
					secondLevelMenus.push(
						getItem(
							secondLevelMenu.title,
							secondLevelMenu.path,
							getIconByPathname(''),
							thirdLevelMenus,
						),
					)
				} else {
					// 特殊处理过滤掉智能化的实例详情/产品管理/设备管理/场景设置/场景控制路由,需要特殊处理
					if (!needTakeQuerysMenuPathnames.includes(secondLevelMenu.path)) {
						secondLevelMenus.push(
							getItem(
								secondLevelMenu.title,
								secondLevelMenu.path,
								getIconByPathname(''),
							),
						)
					}
				}
			}
			firstLevelMenus.push(
				getItem(
					firstLevelMenu.title,
					firstLevelMenu.path,
					getIconByPathname(firstLevelMenu.path),
					secondLevelMenus,
				),
			)
			currentRootSubmenuKeys.push(firstLevelMenu.path)
		}
		// 对currentOpenKeys数组进行去重
		const uniqueOpenKeys = Array.from(new Set(currentOpenKeys))
		setOpenKeys([...uniqueOpenKeys])
		setMenuItems(firstLevelMenus)
		setRootSubmenuKeys([...currentRootSubmenuKeys])
	}

	/* 渲染iOT内页特殊菜单项 */
	const renderSpecialMenuItems = () => {
		let firstLevelMenus: MenuItem[] = []
		let currentRootSubmenuKeys: string[] = []
		let currentOpenKeys: string[] = []
		for (let i = 0; i < menusData?.length; i++) {
			const firstLevelMenu = menusData[i]
			let secondLevelMenus: MenuItem[] = []
			if (firstLevelMenu.path === location.pathname) {
				currentOpenKeys.push(firstLevelMenu.path)
			}
			for (let j = 0; j < firstLevelMenu?.routes.length; j++) {
				const secondLevelMenu = firstLevelMenu?.routes[j]
				if (needTakeQuerysMenuPathnames.includes(secondLevelMenu.path)) {
					firstLevelMenus.push(
						getItem(
							secondLevelMenu.title,
							secondLevelMenu.path,
							getIconByPathname(''),
						),
					)
				}
			}
			currentRootSubmenuKeys.push(firstLevelMenu.path)
		}
		// 对currentOpenKeys数组进行去重
		const uniqueOpenKeys = Array.from(new Set(currentOpenKeys))
		setOpenKeys([...uniqueOpenKeys])
		setSpecialMenuItems(firstLevelMenus)
		dispatch({
			type: 'global/save',
			payload: {
				specialMenuItemsForIot: [...firstLevelMenus],
			},
		})
		// console.log('firstLevelMenus is:', firstLevelMenus)
		setRootSubmenuKeys([...currentRootSubmenuKeys])
	}

	/* 当菜单项展开或收起时触发 */
	const onOpenChange: MenuProps['onOpenChange'] = keys => {
		const latestOpenKey = keys.find(key => openKeys.indexOf(key) === -1)
		if (latestOpenKey && rootSubmenuKeys.indexOf(latestOpenKey!) === -1) {
			setOpenKeys(keys)
		} else {
			setOpenKeys(latestOpenKey ? [latestOpenKey] : [])
		}
	}

	/* 点击菜单项时触发 */
	const onMenuClick: MenuProps['onClick'] = e => {
		history.push({
			pathname: e.key,
			query: needTakeQuerysMenuPathnames.includes(e.key)
				? { ...locationQuerys }
				: {},
		})
	}

	return (
		<div className={styles.firstLevelMenu}>
			{!needTakeQuerysMenuPathnames.includes(location.pathname) && (
				<Menu
					mode="inline"
					openKeys={openKeys}
					onOpenChange={onOpenChange}
					style={{ width: 176 }}
					items={menuItems}
					onClick={onMenuClick}
					selectedKeys={selectedKeys}
					onSelect={item => {
						setSelectedKeys([item.key])
					}}
				/>
			)}
			{needTakeQuerysMenuPathnames.includes(location.pathname) && (
				<>
					<div
						className={styles.backToIotInstance}
						onClick={() => {
							history.push({
								pathname: '/iotInstance',
							})
						}}
					>
						<LeftOutlined
							style={{
								fontSize: '10px',
								marginRight: '10px',
								color: 'rgba(0,0,0,0.85)',
							}}
						/>
						<b>返回工作台</b>
					</div>
					<Menu
						mode="inline"
						openKeys={openKeys}
						onOpenChange={onOpenChange}
						style={{ width: '176px', backgroundColor: '#f7f7f7' }}
						items={specialMenuItems}
						onClick={onMenuClick}
						selectedKeys={selectedKeys}
						onSelect={item => {
							setSelectedKeys([item.key])
						}}
					/>
				</>
			)}
		</div>
	)
}

export default connect(
	({ global, loading }: { global: GlobalModelState; loading: Loading }) => ({
		global,
		loading: loading.models.index,
	}),
)(FirstLevelMenu)
